import clsx from 'clsx';

/**
 * Photo thumbnail with a fallback placeholder for plans that have no
 * photo_url (create/update don't require one — the docs are explicit
 * photo_url comes back null when none was uploaded).
 */
export default function PlanPhoto({ src, alt = '', className }) {
  if (!src) {
    return (
      <div className={clsx('flex items-center justify-center bg-accent-soft text-accent shrink-0', className)}>
        <svg viewBox="0 0 24 24" fill="none" className="h-1/3 w-1/3">
          <path
            d="M4 16l4.5-5 3.5 4 3-3.5L20 16M4 6h16v12H4V6z"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    );
  }
  return <img src={src} alt={alt} className={clsx('object-cover shrink-0', className)} />;
}
